export type AuthCheckStatus = 'authenticated' | 'unauthenticated' | 'unavailable'

export interface AuthCheckResult<T> {
  status: AuthCheckStatus
  user: T | null
}

export type AuthRouteDecision = 'allow' | 'login' | 'dashboard' | 'auth-unavailable'

export interface AuthRouteMeta {
  requiresAuth: boolean
  guestOnly: boolean
}

export function shouldClearAuthContext(status: AuthCheckStatus): boolean {
  return status === 'unauthenticated'
}

export function getSafeAuthRedirect(value: unknown): string {
  return typeof value === 'string'
    && value.startsWith('/')
    && !value.startsWith('//')
    && !value.includes('\\')
    ? value
    : '/dashboard'
}

export function getAuthRouteDecision(meta: AuthRouteMeta, status: AuthCheckStatus): AuthRouteDecision {
  if (meta.requiresAuth && status === 'unavailable') return 'auth-unavailable'
  if (meta.requiresAuth && status === 'unauthenticated') return 'login'
  if (meta.guestOnly && status === 'authenticated') return 'dashboard'
  return 'allow'
}

export async function checkSession<T>(loadCurrentUser: () => Promise<T | null>): Promise<AuthCheckResult<T>> {
  try {
    const user = await loadCurrentUser()
    return user === null
      ? { status: 'unauthenticated', user: null }
      : { status: 'authenticated', user }
  } catch {
    return { status: 'unavailable', user: null }
  }
}
